import api from "@/api";
import translate from "@/helpers/translate"
import mapExampleData from "@/api/mapExampleData";


export default {
    namespaced: true,

    state: {
        stateStatus: [
            {
                text: translate('admin_ChangeStatusToCancelled'),
                value: 'cancelled',
            },
            {
                text: translate('admin_ChangeStatusToSent'),
                value: 'sent'
            },
            {
                text: translate('admin_ChangeStatusToCompleted'),
                value: 'completed'
            }
        ],
    },

    getters: {},

    mutations: {},

    actions: {

        async getSiteInfo(context, {uid_site}) {
            const url = `/admin/sites/${uid_site}`
            try {
                const response = await api.request("get", url);
                return response.data
            } catch (error) {
                throw error;
            }
        },

        async saveSocialList(context, {data, uid_site}) {
            const url = `/admin/sites/${uid_site}/links`
            try {
                const response = await api.request("put", url, data);
                return response.data
            } catch (error) {
                throw error;
            }
        },

        async updateSiteInfo(context, {data, uid_site}) {
            const url = `/admin/sites/${uid_site}`
            const response = await api.request("put", url, data);
            return response.data
        },

        async linkQuestionToPlace(context, url) {
            let data = {
                place_id: sessionStorage.getItem("unlinked_rate_place_guid")
            };
            try {
                return await api.request("put", url, data);
            } catch (error) {
                throw error;
            }
        },

        async getQuestions(context, url) {
            try {
                const response = await api.request("get", url);
                return response.data
            } catch (error) {
                throw error;
            }
        },

        async createQuestion(context, body) {
            const url = "/admin/questions";
            try {
                const response = await api.request("post", url, body);
                return response.data
            } catch (error) {
                throw error;
            }
        },

        async deleteQuestion(context, {questionId, siteUid}) {
            const isUserAdmin = context.rootGetters['auth/isUserAdmin']
            const guid = context.rootGetters['auth/getOrgUid']
            const url = isUserAdmin ? `/admin/questions/${questionId}` : `/admin/organizations/${guid}/sites/${siteUid}/questions/${questionId}`;
            try {
                const response = await api.request("delete", url);
                return response.data
            } catch (error) {
                throw error;
            }
        },

        async updateQuestion(context, {questionId, body, siteUid}) {
            const isUserAdmin = context.rootGetters['auth/isUserAdmin']
            const guid = context.rootGetters['auth/getOrgUid']
            const url = isUserAdmin ? `/admin/questions/${questionId}` : `/admin/organizations/${guid}/sites/${siteUid}/questions/${questionId}`;
            try {
                const response = await api.request("put", url, body);
                return response.data
            } catch (error) {
                throw error;
            }
        },

        async connectQuestionToPlace(context, {questionId, body}) {
            const isUserAdmin = context.rootGetters['auth/isUserAdmin']
            const isUserOwner = context.rootGetters['auth/isUserOwner']
            const hasOwnOrganization = context.rootGetters['auth/hasOwnOrganization']
            const hasOwnPlace = context.rootGetters['auth/hasOwnPlace']
            const ownerWithOrganAndPlace = isUserOwner && hasOwnOrganization && hasOwnPlace

            const role = isUserAdmin || ownerWithOrganAndPlace ? 'admin' : 'api/v1'
            const url = `/${role}/questions/${questionId}/place`;
            return await api.request("put", url, body);
        },

        async connectQuestionToPlaceAdmin(context, {questionId, body}) {
            const url = `/admin/questions/${questionId}/place`;
            return await api.request("put", url, body);
        },

        async connectQuestionByIdToPlace(context, {body}) {
            const url = `/admin/questions/place`;
            return await api.request("put", url, body);
        },

        async connectQuestionToManager(context, {questionId, siteUid}) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/sites/${siteUid}/questions/${questionId}/place`;
            return await api.request("put", url);
        },

        async addQuestionToPlace(context, body) {
            const url = `/admin/questions/addToPlace`;
            try {
                const response = await api.request("post", url, body);
                return response.data
            } catch (error) {
                throw error;
            }
        },

        async fetchUnlinkedQuestions(context, obj) {
            const url = `/admin/questions/unlinked?page=${obj.page}`;
            try {
                const response = await api.request("get", url);
                return response.data
            } catch (error) {
                throw error;
            }
        },

        async setMultipleQuestionAsPrinted(context, questionIds) {
            const url = `/admin/questions/setAsPrinted`
            const body = {
                qrs: questionIds
            }
            return await api.request("put", url, body);
        },

        async removeMultiplePrintedFlag(context, questionIds) {
            const url = `/admin/questions/setAsNotPrinted`
            const body = {
                qrs: questionIds
            }
            return await api.request("put", url, body);
        },

        async fetchVotes(context, data) {
            const url = `/admin/votes?page=${data.page}&votes=${data.votes}&s=${data.s}`
                + `&admin_votes=${data.admin_votes}&sl=${data.sl}&place=${data.place}`
                + `&with_sld=${data.with_sld}&with_img=${data.with_img}&with_audio=${data.with_audio}`
                + `&wgps=${data.with_user_gps}&wogps=${data.without_user_gps}&with_contact_info=${data.with_contact_info}`
                + `&wqgps=${data.with_question_gps}&woqgps=${data.without_question_gps}`
                + `&with_empty_plcmnt=${data.with_empty_plcmnt}`
                + `&q_id=${data.q_id}&org_id=${data.org_id}&user_id=${data.user_id}&reg_user_id=${data.reg_user_id}`
                + `&comment=${data.comment}&with_comments=${data.with_comments}&empty_asset_id=${data.with_empty_asset_id}`
                + `&g_review=${data.g_review}&r_id=${data.rate_id}`
            const responce = await api.request("get", url);
            return responce.data;
        },

        async getChartInfoByQuestion(context, {questionIds, placeIds, params}) {
            // console.log('######################################')
            // console.log('params', params)
            // console.log('questionIds', questionIds)
            // console.log('placeIds', placeIds)
            // console.log('######################################')
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/getChartData`
            let body = {
                date_from_local: params.dateFrom,
                date_to_local: params.dateTo,
                date_type: params.dateType,
            }
            if (placeIds) {
                body.place_uids = placeIds
            }
            if (questionIds) {
                body.question_uids = questionIds
            }
            const response = await api.request("post", url, body);
            return response.data;
        },

        async fetchQuestionSuggestions() {
            const url = `/api/v1/templates`
            const response = await api.request("get", url);
            return response.data;
        },

        async fetchLocationSuggestions() {
            const url = `/api/v1/optionals`
            const response = await api.request("get", url);
            return response.data;
        },

        async fetchSelectedStartTemplates() {
            const url = `/api/v1/startTemplates`
            const response = await api.request("get", url);
            return response.data;
        },

        async connectSelectedStartTemplates(context, {siteUid}) {
            const orgGuid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${orgGuid}/sites/${siteUid}/questions/start-templates`
            const response = await api.request("post", url);
            return response.data;
        },

        async clearSelectedStartTemplates() {
            const url = `/api/v1/startTemplates`
            const response = await api.request("delete", url);
            return response.data;
        },
        async bulkPlaceEdit(context, body) {
            const url = '/api/v1/questions/bulkEdit'
            return await api.request("put", url, body)
        },

        async importCro(context, {siteId, file}) {
            const url = `/admin/questions/importCroAssets`;
            let formData = new FormData();
            formData.append('place_id', siteId);
            formData.append('import_data', file);
            const response = await api.request("post", url, formData);
            return response.data
        },

        async importCroFog(context, {tenantId, file}) {
            const url = `/admin/questions/importCroFog`;
            let formData = new FormData();
            formData.append('tenant_id', tenantId);
            formData.append('import_data', file);
            const response = await api.request("post", url, formData);
            return response.data
        },

        async uploadLandingFile(context, {createShortLink, tag, file}) {
            const url = `/admin/files`;
            let formData = new FormData();
            if(tag != null) formData.append('tag', tag);
            formData.append('create_short_link', createShortLink);
            formData.append('file', file);
            const response = await api.request("post", url, formData);
            return response.data
        },
        async getLandingFiles(context, obj) {
            let url = `/admin/files?page=${obj.page}`;
            const response = await api.request('get', url);
            return response.data;
        },
        async fetchSecondLevelConfigForQuestion(context, obj) {
            const url = `/admin/organizations/${obj.org_guid}/sites/${obj.place_guid}/questions/${obj.question_guid}/secondLevelConfig`
            try {
                const response = await api.request("get", url)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async fetchServiceLogConfigForQuestion(context, obj) {
            const url = `/admin/organizations/${obj.org_guid}/sites/${obj.place_guid}/questions/${obj.question_guid}/serviceLogConfig`
            try {
                const response = await api.request("get", url)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async saveSecondLevelConfigForQuestion(context, obj) {
            const url = `/admin/organizations/${obj.org_guid}/sites/${obj.place_guid}/questions/${obj.question_guid}/addSecondLevelConfig`
            {
                try {
                    const response = await api.request("put", url, obj)
                    return response.data
                } catch (e) {
                    throw e
                }
            }
        },
        async saveServiceLogConfigForQuestion(context, obj) {
            const url = `/admin/organizations/${obj.org_guid}/sites/${obj.place_guid}/questions/${obj.question_guid}/addServiceLogConfig`
            {
                try {
                    const response = await api.request("put", url, obj)
                    return response.data
                } catch (e) {
                    throw e
                }
            }
        },
        async getIconsForBlockImagesSld(context) {
            const url = `/api/sec-level-images`
            try {
                const response = await api.request("get", url)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async getQuestionsMap(context, {hash}) {
            const url = `/api/places/${hash}/mapData`
            try {
                const response = await api.request("get", url)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async getQuestionsLocationHistory(context, {hash, qId}) {
            const url = `/api/places/${hash}/questions/${qId}/location-history`
            try {
                const response = await api.request("get", url)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async getQuestionsLocationHistoryDashboard(context, {question_id}) {
            const url = `/api/v1/questions/${question_id}/location-history`
            try {
                const response = await api.request("post", url, null,null, false, mapExampleData.getMapExampleAdditionHeaders(context))
                return response.data
            } catch (e) {
                throw e
            }
        },
        async fixLocationIssueForQuestion(context, {hash, qId}) {
            const url = `/api/places/${hash}/questions/${qId}/fix-issue`
            try {
                const response = await api.request("post", url)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async fixLocationIssueForQuestionA(context, {guid}) {
            const url = `/api/v1/questions/${guid}/fix-issue`
            try {
                const response = await api.request("post", url)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async assignGpsToQuestion(context, body) {
            const url = `/api/v1/questions/assign-gps`
            try {
                const response = await api.request("post", url, body)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async logUnauthorizedLocationIssueFix(context, {hash, qId}) {
            const url = `/api/places/${hash}/questions/${qId}/fix-issue/no-access`
            try {
                const response = await api.request("post", url)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async saveNewIcon(context, body) {
            let formData = new FormData();
            formData.append('tag', body.tag)
            formData.append('default_text', body.default_text)
            formData.append('is_svg', body.is_svg)
            for (var i = 0; body.file.length > i; i++) {
                formData.append('file[]', body.file[i])
            }

            let url = `/admin/sec-level-images`
            try {
                const response = await api.request("post", url, formData, null, true)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async deleteIcon (context, image_guid) {
            const url = `/admin/sec-level-images/${image_guid}`
            try {
                const response = await api.request("delete", url, null, null, true)
                return response.data
            } catch (e) {
                throw e
            }
        },
        async editIconSld (context, body) {
            let formData = new FormData();
            formData.append('tag', body.tag)
            formData.append('default_text', body.default_text)
            formData.append('is_svg', body.is_svg)
            for (var i = 0; body.file.length > i; i++) {
                formData.append('file[]', body.file[i])
            }
            let url = `/admin/sec-level-images/${body.image_guid}`
            try {
                const response = await api.request("post", url, formData, null, true)
                return response.data
            } catch (e) {
                throw e
            }
        }

    }
};
